// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_9bd","rootNoMargin":"styles_rootNoMargin__3OIzH"};